import { useMemo } from 'react';
import type { Artwork } from '~/api/types';
import type { SupportedLanguage } from '~/lib/i18n';
import type { MediaType } from './types';

export const useArtworkMedia = (artwork: Artwork, lang: SupportedLanguage) => {
  return useMemo(() => {
    const { audio_guide, audio_description, sign_language, artwork_video } = artwork;
    return [
      {
        type: 'audioguide' as MediaType,
        url: audio_guide[lang].file,
        transcription: audio_guide[lang].transcription,
      },
      {
        type: 'audiodescription' as MediaType,
        url: audio_description[lang].file,
        transcription: audio_description[lang].transcription,
      },
      {
        type: 'signlanguage' as MediaType,
        url: sign_language[lang].file,
        transcription: sign_language[lang].transcription,
      },
      {
        type: 'video' as MediaType,
        url: artwork_video[lang].file,
        transcription: artwork_video[lang].transcription,
      },
    ].filter(({ url }) => !!url);
  }, [artwork, lang]);
};
